import { cx } from '../lib/cx';
import { handleRadioGroupKey } from '../lib/radioGroupKeys';

export interface ScaleInputProps {
  id: string;
  label: string;
  hint?: string;
  /** `null` = još nije odgovoreno; to je legitimno stanje, ne nula. */
  value: number | null;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
}

/**
 * Ocjena 1–5 (energija, san). Namjerno gumbi, ne `range`: klizač na mobitelu
 * traži preciznost koju prst nema, a pet meta se pogađa iz prve.
 */
export function ScaleInput({
  id,
  label,
  hint,
  value,
  onChange,
  min = 1,
  max = 5,
  disabled = false,
}: ScaleInputProps) {
  const options = Array.from({ length: max - min + 1 }, (_, i) => min + i);
  return (
    <fieldset disabled={disabled} className="min-w-0">
      <legend className="mb-2 text-[14.5px] text-ink">{label}</legend>
      <div role="radiogroup" aria-label={label} id={id} className="flex gap-2">
        {options.map((option, index) => {
          const selected = value === option;
          return (
            <button
              key={option}
              type="button"
              role="radio"
              aria-checked={selected}
              /* Ocjena je jedna postaja tabulatora; 1–5 se bira strelicama. */
              tabIndex={selected || (value === null && index === 0) ? 0 : -1}
              disabled={disabled}
              onKeyDown={(e) => handleRadioGroupKey(e, index, options, onChange)}
              onClick={() => onChange(option)}
              className={cx(
                'h-11 flex-1 rounded-md text-[15px] transition-colors duration-200',
                selected
                  ? 'border-2 border-accent bg-accent-light text-ink'
                  : 'border border-line bg-surface text-ink-muted hover:border-line-strong',
                disabled && 'pointer-events-none opacity-40',
              )}
            >
              {option}
            </button>
          );
        })}
      </div>
      {hint && <p className="mt-1.5 text-[12px] text-ink-muted">{hint}</p>}
    </fieldset>
  );
}
